import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { pageFooterDataEn } from './pageFooterData.en';
import { pageFooterDataEs } from './pageFooterData.es';
import type { PageFooterData } from './types/PageFooterData';

export const pageFooterDataByLocale: Record<I18nLocale, PageFooterData> = {
  en: pageFooterDataEn,
  es: pageFooterDataEs,
};
